import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { IconEye, IconEyeOff } from '@tabler/icons-react'

import worksList from "../../data/WorksData";

function FormEnterpriceSign() {

    const [ tooglePassword, setTooglePassword ] = useState(false);

    const handleSubmitLogin = (e) => {
        e.preventDefault();
        alert('Please enter your password');
    }

    return (

        <form className='--form-lgn-enterprice' method='POST' onSubmit={handleSubmitLogin}>

            <div className='--row-form-lgn-enterprice'>

                <div className='--col-form-lgn-enterprice'>

                    <h4>Completa la información de tu usuario</h4>

                    <div className='--form-group --form-group--flex'>

                        <div className='--form-row'>

                            <label htmlFor='entryName' className='--label-form-lgn'>Nombre(s)*</label>

                            <div className='--form-control'>
                                <input type='text' className='--entry-form-lgn' name='entryName' id='entryName' placeholder='Ingresa tu nombre' aria-placeholder='Ingresa tu nombre' autoComplete='off' />
                            </div>

                        </div>

                        <div className='--form-row'>

                            <label htmlFor='entryLastName' className='--label-form-lgn'>Apellido(s)*</label>

                            <div className='--form-control'>
                                <input type='text' className='--entry-form-lgn' name='entryLastName' id='entryLastName' placeholder='Ingresa tu apellido' aria-placeholder='Ingresa tu apellido' autoComplete='off' />
                            </div>

                        </div>

                    </div>

                    <div className='--form-group'>

                        <label htmlFor='entryEmail' className='--label-form-lgn'>Email o correo electrónico</label>

                        <div className='--form-control'>
                            <input type='email' className='--entry-form-lgn' name='entryEmail' id='entryEmail' placeholder='Ingresa tu Email o correo electrónico' aria-placeholder='Ingresa tu Email o correo electrónico' autoComplete='off' />
                        </div>

                    </div>

                    <div className='--form-group'>

                        <label htmlFor='entryPassword' className='--label-form-lgn'>Contraseña</label>

                        <div className='--form-control'>
                            <input type={`${tooglePassword ? 'text' : 'password'}`} className='--entry-form-lgn --entry-form-lgn--password' name='entryPassword' id='entryPassword' placeholder='Ingresa tu contraseña' aria-placeholder='Ingresa tu contraseña' autoComplete='off' />
                            <span className='--ico-form-lgn' onClick={() => setTooglePassword(!tooglePassword)}>{tooglePassword ? <IconEye/> : <IconEyeOff/>}</span>
                        </div>

                    </div>

                </div>

                <div className='--col-form-lgn-enterprice'>

                    <h4>Ingresa los datos de la empresa</h4>

                    <div className='--form-group --form-group--flex'>

                        <div className='--form-row'>

                            <label htmlFor='entryNameIndustry' className='--label-form-lgn'>Nombre de la empresa</label>

                            <div className='--form-control'>
                                <input type='text' className='--entry-form-lgn' name='entryNameIndustry' id='entryNameIndustry' placeholder='Ingresa el nombre de la empresa' aria-placeholder='Ingresa el nombre de la empresa' autoComplete='off' />
                            </div>

                        </div>

                        <div className='--form-row'>

                            <label htmlFor='entryBusinessName' className='--label-form-lgn'>Razón social</label>

                            <div className='--form-control'>
                                <input type='text' className='--entry-form-lgn' name='entryBusinessName' id='entryBusinessName' placeholder='Ingresar razón social' aria-placeholder='Ingresar razón social' autoComplete='off' />
                            </div>

                        </div>

                    </div>

                    <div className='--form-group --form-group--flex'>

                        <div className='--form-row'>

                            <label htmlFor='entryPhone' className='--label-form-lgn'>Número de teléfono</label>

                            <div className='--form-control'>
                                <input type='text' className='--entry-form-lgn' name='entryPhone' id='entryPhone' placeholder='Ingresa tu nombre' aria-placeholder='Ingresa tu nombre' autoComplete='off' />
                            </div>

                        </div>

                        <div className='--form-row'>

                            <label htmlFor='entryIndustry' className='--label-form-lgn'>Industria</label>

                            <div className='--form-control'>
                                <input type='text' className='--entry-form-lgn' name='entryIndustry' id='entryIndustry' list='entryIndustryList' placeholder='Ingresa tu apellido' aria-placeholder='Ingresa tu apellido' autoComplete='off' />
                                <datalist id='entryIndustryList'>
                                    {worksList.map((industry, i) => (
                                        <option value={industry} key={i} />
                                    ))}
                                </datalist>
                            </div>

                        </div>

                    </div>

                    <div className='--form-group'>

                        <label htmlFor='entryRUC' className='--label-form-lgn'>Número de RUC</label>

                        <div className='--form-control'>
                            <input type='email' className='--entry-form-lgn' name='entryRUC' id='entryRUC' placeholder='Ingresa el número de RUC' aria-placeholder='Ingresa el número de RUC' autoComplete='off' />
                        </div>

                    </div>

                    <div className='--form-group'>

                        <label htmlFor='entryLocation' className='--label-form-lgn'>Dirección</label>

                        <div className='--form-control'>
                            <input type={`text`} className='--entry-form-lgn' name='entryLocation' id='entryLocation' placeholder='Ingresa su dirección' aria-placeholder='Ingresa su dirección' autoComplete='off' />
                        </div>

                    </div>

                </div>
            
            </div>

            <div className='--tyc-form-lgn-enterprice'>

                <div className='--form-group'>
                    <div className='--form-control--checkbox'>
                        <input type='checkbox' name='tyc' id='tyc' />
                        <label htmlFor='tyc'>Acepto las <Link>Condiciones de uso</Link> y las <Link>Políticas de privacidad</Link> de Chambita. *</label>
                    </div>
                    <div className='--form-control--checkbox'>
                        <input type='checkbox' name='nyp' id='nyp' />
                        <label htmlFor='nyp'>Acepto recibir <Link>Novedades y Promociones</Link></label>
                    </div>
                    <div className='--form-control--checkbox'>
                        <input type='checkbox' name='nyp' id='nyp' />
                        <label htmlFor='nyp'>Quiero participar en encuestas y pruebas piloto para ayudar a mejorar la plataforma.</label>
                    </div>
                </div>

            </div>

            <div className='--wrap-btn-lgn'>
                <button className='--btn --btn-lgn'>Crear cuenta</button>
            </div>

        </form>

    )

}

export default FormEnterpriceSign